module.exports = __webpack_public_path__ + "podcast-collection-new-fe6ea830bcac40805d7e.png";